<app-price-breakdown [selectedRow]="data.params.data" [isFlexedCol]="data.isFlexedCol"></app-price-breakdown>